/**
 * Classificação de eventos para política de retry.
 */

import type { SendEventParams } from '../../utils/sendEvent';

export type RetryClass = 'critical' | 'medium' | 'low';

const CRITICAL = new Set<string>([
  'PURCHASE',
  'LEAD',
  'INITIATE_CHECKOUT',
  'ADD_PAYMENT_INFO',
  'SUBSCRIPTION',
]);

const MEDIUM = new Set<string>(['PAGE_VIEW', 'VIEW_CONTENT', 'ADD_TO_CART']);

export function classifyRetry(eventType: SendEventParams['type']): RetryClass {
  if (CRITICAL.has(eventType)) return 'critical';
  if (MEDIUM.has(eventType)) return 'medium';
  return 'low';
}
